import _ from 'lodash';
import * as at from './actionTypes';

const INITIAL_STATE = {
  tagsToAdd: [],
  entriesToAdd: [],
  loading: false
}

export const reducer = (state = INITIAL_STATE, action) => {
  switch(action.type) {
    case at.ENTRY_REMOVE:
      return {
        ...state,
        entriesToAdd: _.filter(state.entriesToAdd, (e) => e.url !== action.payload)
      }
    case at.OPEN_MODAL:
      return {
        ...state,
        entriesToAdd: _.union(state.entriesToAdd, action.payload)
      }
    case at.TAGS_UPDATED_IN_SELECTION:
      return {
        ...state,
        tagsToAdd: action.payload,
      };
    case at.CANCEL_ADDING:
      return { ...INITIAL_STATE }
    case at.DONE_EDITING:
      return { ...INITIAL_STATE }
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/scenes/EntriesAddModal/reducer.js